import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import AdminOnly from '../../components/admin-workspace/AdminOnly';

const CreateCompanies = lazy(() => import('../../container/companies/CreateCompanies'));
const CompaniesListTable = lazy(() => import('../../container/companies/CompaniesListTable'));
const EditClient = lazy(() => import('../../container/companies/EditClient'));

function CompaniesRoutes() {
  const { path } = useRouteMatch();
  return (
    <AdminOnly><Switch>
      <Route path={`${path}/v1/create`} component={CreateCompanies} />
      <Route path={`${path}/v1/overview`} component={CompaniesListTable} />
      <Route path={`${path}/v1/edit/:userId`} component={EditClient} />
    </Switch></AdminOnly>
  );
}

export default CompaniesRoutes;
